export default "__VITE_ASSET__DLVle729__"